/**
 * Internal dependencies
 */
import BlockArchiveManager from './block-archive-manager';
import BlockBeforeAfterManager from './block-before-after-manager';
import BlockSliderManager from './block-slider-manager';
import BlockTabManager from './block-tab-manager';
import ViewportManager from './viewport-manager';

/**
 * @note L'objet wmuwpb est initialisé dans /includes/front/scripts.php
 * @todo Réorganiser tout ça
 */

let styleElement = null;
let layoutElement = null;
let layoutWidth = null;

const blockArchiveManager = new BlockArchiveManager();
const blockBeforeAfterManager = new BlockBeforeAfterManager();
const blockSliderManager = new BlockSliderManager();
const blockTabManager = new BlockTabManager();

export {
	blockArchiveManager,
	blockBeforeAfterManager,
	blockSliderManager,
	blockTabManager,
};

/**
 * 
 */
const getLayoutElement = () =>
{
	if ( null === layoutElement && wmuwpb.layoutSelector )
	{
		if ( wmuwpb.layoutSelector )
		{
			layoutElement = document.querySelector( wmuwpb.layoutSelector );
		}

		if ( ! layoutElement )
		{
			layoutElement = document.querySelector( '#content' );
		}

		if ( ! layoutElement )
		{
			layoutElement = document.querySelector( 'body' );
		}
	}

	return layoutElement;
}

/**
 * 
 */
const getStyleElement = () =>
{
	if ( null === styleElement )
	{
		styleElement = document.createElement( 'style' );
		styleElement.setAttribute( 'type', 'text/css' );
		document.querySelector( 'head' ).appendChild( styleElement );
	}

	return styleElement;
}

/**
 * 
 */
const updateLayoutWidth = () =>
{
	let layoutEl = getLayoutElement();

	if ( layoutEl && layoutEl.clientWidth !== layoutWidth )
	{
		let styleEl = getStyleElement();

		if ( styleEl )
		{
			layoutWidth = layoutEl.clientWidth;
			styleEl.innerHTML = ':root { --wmu-layout-width: ' + layoutWidth + 'px; }';
		}
	}
}

/**
 * @todo Prendre en charge la valeur potentielle existante de style hors de notre système relatif au viewport.
 */
const updateBlocksStyle = () =>
{
	const viewportCurrent = ViewportManager.viewportCurrent.toLowerCase();
	const viewportPrevious = ViewportManager.viewportPrevious.toLowerCase();

	/**
	 * Switch {viewportCurrent}-style attribute to style attribute.
	 */
	[].forEach.call( document.querySelectorAll( `[${viewportCurrent}-style]` ), ( element ) =>
	{
		element.setAttribute( 'style', element.getAttribute( `${viewportCurrent}-style` ) );
	} );

	/**
	 * Remove style attribute for elements which not have custom style in the current viewport.
	 */
	if ( viewportPrevious )
	{
		[].forEach.call( document.querySelectorAll( `[${viewportPrevious}-style]:not([${viewportCurrent}-style])` ), ( element ) =>
		{
			element.removeAttribute( 'style' );
		} );
	}
};

/**
 * 
 */
const initGlobalBlockLink = () =>
{
	[].forEach.call( document.querySelectorAll( '.block-global-link' ), ( element ) =>
	{
		const blockElement = element.closest( '.wmu-block' );
		const href = element.getAttribute( 'href' );

		if ( blockElement && href )
		{
			blockElement.classList.add( 'has-global-link' );
			blockElement.addEventListener( 'click', ( event ) =>
			{
				window.location = href;
			} );
		}
	} );
};

/**
 * 
 */
window.addEventListener( 'resize', ( event ) =>
{
	ViewportManager.check();
	updateLayoutWidth();
} );

/**
 * 
 */
document.addEventListener( 'DOMContentLoaded', ( event ) =>
{
	ViewportManager.check();
	initGlobalBlockLink();
	updateLayoutWidth();
} );

/**
 * 
 */
document.addEventListener( 'WMUViewportChange', ( event ) =>
{
	updateBlocksStyle();
} );